module.exports = __webpack_public_path__ + "img/IMG-20200510-WA0005.9a309ff7.jpg";